import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { useEffect, useState } from "react";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyATzMuy_mmhf0Jbh1cqiuDXHOP6jEucoi8",
  authDomain: "lighthouse-staking.firebaseapp.com",
  projectId: "lighthouse-staking",
  storageBucket: "lighthouse-staking.appspot.com",
  messagingSenderId: "859513282465",
  appId: "1:859513282465:web:ca2f2aace3718a8371f5e0",
  measurementId: "G-LVP8X62D96"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);
const db = getFirestore(app);

export const useAuth = () => {
  const [currentUser, setCurrentUser] = useState();
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => setCurrentUser(user));
    return unsub;
  }, []);
  return currentUser;
};

export { auth, app, storage, db };
